import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";

// Pages
import ContactWindow from "./pages/ContactWindow";
import InvoiceWindow from "./pages/InvoiceWindow";
import SyncSettings from "./pages/SyncSettings";
import SubscriptionWindow from "./pages/SubscriptionWindow";
import Setup from "./pages/Setup";
import Authentication from "./pages/Authentication";
import EnvironmentSelection from "./pages/EnvironmentSelection";
import InfoModal from "./components/Modals/InfoModal";
import LogsIframe from "./pages/LogsIframe";
import SetupGuide from "./pages/SetupGuide";
import ExtensionCheck from "./pages/ExtensionCheck";
import MSBCExtension from "./pages/MSBCExtension";
import StaticPricing from "./pages/StaticPricing";
import Redirect from "./pages/Redirect";
import CmsNotifications from "./helpers/cms/CmsNotifications";
import CheckExtensionModal from "./components/Modals/CheckExtensionModal";

import { CmsProvider } from "./helpers/cms/cmsHook";

import "./App.css";

function App() {
  return (
    <CmsProvider>
      <Router>
        <InfoModal />
        <CheckExtensionModal />
        <ToastContainer
          toastClassName={"react-toast"}
          position="top-center"
          autoClose={3000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
        <Routes>
          <Route path="/syncsettings" element={<SyncSettings />} />
          <Route path="/contactwindow" element={<ContactWindow />} />
          <Route path="/invoicewindow" element={<InvoiceWindow />} />
          <Route path="/subscription" element={<SubscriptionWindow />} />
          <Route path="/setup" element={<Setup />} />
          <Route path="/oauth" element={<Authentication />} />
          <Route path="/env" element={<EnvironmentSelection />} />
          <Route path="/retrigger" element={<LogsIframe />} />
          <Route path="/setupguide" element={<SetupGuide />} />
          <Route path="/extension" element={<MSBCExtension />} />
          <Route path="/extension-check" element={<ExtensionCheck />} />
          <Route path="/static-pricing" element={<StaticPricing />} />
          <Route path="/redirect" element={<Redirect />} />
          <Route path="/edit-notifications" element={<CmsNotifications />} />
        </Routes>
      </Router>
    </CmsProvider>
  );
}

export default App;
